export const TIMEOUT = 120000;

export default {
  TIMEOUT
};
